import { Box, capitalize, Typography } from '@mui/material';
import BasicForm from './BasicForm';
import RegisterLayout from '..';
import { useSelector } from 'react-redux';
import useSnackBarMessage from '../../../helper/customHooks/useFetchMessage';
import SnackBarComponent from '../../Common/SnackBar';
import { useState } from 'react';

const CoderRegistration = () => {
  const userRegisterData = useSelector((state: any) => state?.register);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [showMessages, setShowMessages]: any = useSnackBarMessage(
    false,
    '',
    userRegisterData.error
  );

  return (
    <>
      <RegisterLayout>
        <Box className="form-wrapper">
          <Box my={2} textAlign={'start'}>
            <Typography variant="h1">
              {'Sign up as '}
              <Typography component={'span'} fontSize={'32px'} fontWeight={500}>
                {'Coder'}
              </Typography>
            </Typography>
          </Box>
          <BasicForm
            role={'CODER'}
            setShowMessages={setShowMessages}
            showMessages={showMessages}
            setIsOpen={setIsOpen}
          />
        </Box>
      </RegisterLayout>
      {showMessages?.showSnackBar && (
        <SnackBarComponent
          isOpen={showMessages?.showSnackBar}
          isClose={(prev: any) => ({
            ...prev,
            showSnackBar: false
          })}
          message={showMessages?.snackBarMessage}
          messageType={showMessages?.messageType}
        />
      )}
    </>
  );
};

export default CoderRegistration;
